module.exports = __webpack_public_path__ + "img/20210512.87733b17.gif";